export default __webpack_public_path__ + "static/media/arrow_left_active.5a93f8c9.PNG";